
<!-- 获取车场协议 -->
<template>
	<div class="">
		<right-structure :Pdatas='infoData'>
			<pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
			<pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
		</right-structure>
	</div>
</template>

<script>
	import structure from "@/components/commonStructure"

	export default {
		name: '',
		components: {
			'right-structure': structure,
		},
		props: ['commonUrls'],
		data() {
			return {
				requestBody: {

				},
				responseCode: {
					"data": {
					},
					"message": "业务成功",
					"resultCode": 0,
					"status": 1
				},
				infoData: {
					explain: "第三方接入系统请求智慧停车开放平台 查询车辆的车主及VIP",
					t_url: this.commonUrls.test + "getCarOwnerAndVipType",
					p_url: this.commonUrls.prod + "getCarOwnerAndVipType",
					precondition: "无",
					fitSystem: "VEMS传统停车场，云停车场",
					pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
					Q_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [
              { info1: 'parkCode', info2: '是', info3: 'Long', info4: '车场编码' },
              { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号' },
					 ]
					}
          ],
					R_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [
              { info1: 'carCode', info2: '否', info3: 'Long', info4: '车牌号码' },
              { info1: 'carOwner', info2: '否', info3: 'String', info4: '车主姓名' },
              { info1: 'phone', info2: '否', info3: 'String', info4: '手机号码' },
              { info1: 'vipType', info2: '否', info3: 'Integer', info4: 'VIP类型：0未定义，1普通，2本地VIP，3外部VIP，4黑名单，5访客，6预定车位车辆，7共享车位车辆，8红名单，（目前没有' },
              { info1: 'vipTypeName', info2: '否', info3: 'String', info4: 'VIP类型名称' },
              { info1: 'vipTypeId', info2: '否', info3: 'Long', info4: 'VIP类型ID' },
						]
					}],
					codeStatus: [{
						titleName: null,
						tabledata: [{
							tableHead: '状态码',
							tdName: 'info1'
						}, {
							tableHead: '说明',
							tdName: 'info2'
						}],
						td: [{
							info1: '000110',
							info2: '失败',
						}, {
							info1: '00110000',
							info2: '失败',
						}, {
							info1: '110000',
							info2: '失败',
						}]
					}],
				}
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/getCarOwnerAndVipType.vue